import { Box, Typography } from "../../../../../../components";

export function ErrorProdutoAI() {
  return (
    <Box sx={{ textAlign: "center", py: 4 }}>
      <i
        className="ph-fill ph-x-circle bg-danger p-3 rounded-circle"
        style={{ color: "#fff", fontSize: 32 }}
      />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Erro na análise
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Tivemos um problema ao processar a análise fiscal. Por favor, tente
        novamente mais tarde.
      </Typography>
    </Box>
  );
}
